define('modules/accounts/companies/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");
    var BaseModel = require("base/model");

    var model = BaseModel.extend({
        initialize: function() {
            this.initRequestEvents();
        },
        urlRoot: function() {
            return Config.backendUrl + "/accounts/companies";
        }
    });

    module.exports = model;
});

